// @ts-strict-ignore
import { KeyValuePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { appInject } from 'src/app/app-injector';
import { LazyComponentId } from 'src/app/core/services/lazy-components/lazy-components-registry';
import {
  selectOutletId,
  selectRuntimeVariablesOrUndefined
} from 'src/app/store/runtime-variables/runtime-variables.selectors';
import { filterChanged, filterTruthy } from 'src/app/utils/functions/rx-filters';
import { Outlet } from 'src/app/utils/models/outlet.interface';
import { Subprocess } from 'src/app/utils/models/subprocess.enum';

import { ImageComponent } from '../images/image/image.component';
import { ModalLinkDirective } from '../modal/modal-link/modal-link.directive';
import { BypassHtmlSecurityPipe } from '../pipes/bypass-html-security/bypass-html-security.pipe';
import { TranslatePipe } from '../pipes/translate/translate.pipe';

import { DealerLocatorLocation } from './dealer-locator-location.enum';
import { dealerLocatorStartLoadAction } from './store/dealer-locator.actions';
import { selectOutlets } from './store/dealer-locator.selectors';

@Component({
  selector: 'cc-dealer-locator',
  templateUrl: './dealer-locator.component.html',
  styleUrls: ['./dealer-locator.component.scss', '../footer/footer-links/footer-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgFor,
    ModalLinkDirective,
    ImageComponent,
    KeyValuePipe,
    BypassHtmlSecurityPipe,
    TranslatePipe
  ]
})
export class DealerLocatorComponent implements OnInit {
  @Input() public location: DealerLocatorLocation = DealerLocatorLocation.Body;

  public outlet: Outlet;
  public subprocess: Subprocess;
  public subprocessCheck = Subprocess.CCri;
  public dealerLocatorLocation = DealerLocatorLocation;

  public readonly copyrightInfo = 'copyright-info';
  public readonly modalComponent = LazyComponentId.FooterRetailerModal;

  public constructor(
    private readonly store: Store,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.store
      .pipe(selectRuntimeVariablesOrUndefined)
      .pipe(filterTruthy(), first(), takeUntilDestroyed(appInject(DestroyRef)))
      // dont subscribe here but use proper selector and use async pipe
      .subscribe(data => (this.subprocess = data.subprocess));

    this.store
      .select(selectOutletId)
      .pipe(filterChanged(), filterTruthy(), takeUntilDestroyed(appInject(DestroyRef)))
      .subscribe(outletId => {
        this.store.dispatch(dealerLocatorStartLoadAction({ payload: { outletId } }));

        // prevent subscribe within subscribe
        this.store
          .select(selectOutlets)
          .pipe(takeUntilDestroyed(appInject(DestroyRef)))
          .subscribe(outlets => {
            this.outlet = outlets.find(outlet => outlet.outletId === outletId);
            this.changeDetectorRef.markForCheck();
          });
      });
  }
}
